/**
 * Policy Canvas Error Fallback Component
 *
 * Error boundary fallback for the PolicyCanvas component.
 * Displays a user-friendly error message when the canvas fails to render.
 */

import React from 'react';
import styled from 'styled-components';
import { Box, Text } from '@usealloy/component-library';

/**
 * Props for the error fallback component
 */
interface PolicyCanvasErrorFallbackProps {
  error: Error;
}

/**
 * Container for error fallback content
 */
const ErrorContainer = styled(Box)`
  height: 400px;
  padding: 20px;
  text-align: center;
`;

/**
 * Error title text
 */
const ErrorTitle = styled(Text)`
  margin-bottom: 16px;
  color: var(--cl-red-500);
`;

/**
 * Error description text
 */
const ErrorDescription = styled(Text)`
  margin-bottom: 16px;
  color: var(--cl-gray-600);
`;

/**
 * Error message text
 */
const ErrorMessage = styled(Text)`
  margin-bottom: 20px;
  font-size: 12px;
  color: var(--cl-gray-500);
`;

/**
 * Error fallback component for PolicyCanvas
 */
export const PolicyCanvasErrorFallback: React.FC<PolicyCanvasErrorFallbackProps> = ({
  error,
}) => (
  <ErrorContainer direction="column" alignItems="center" justifyContent="center">
    <ErrorTitle>Journey Canvas Error</ErrorTitle>
    <ErrorDescription>
      There was an error rendering the journey canvas.
    </ErrorDescription>
    <ErrorMessage>{error.message}</ErrorMessage>
  </ErrorContainer>
);
